import { cx } from '@linaria/core';
import { useCallback, Fragment } from 'react';
import { resets } from '@ui/css';
import { useObservedValue, IsomorphicPortal } from '@utils/react';
import { PrinterThrobber } from './before-print/atom.throbber.js';
import { PrintContext } from './context.print.js';
import { PrintRoot } from './populate-print-target/comp.root.js';
import { printerSelectors } from './selectors.js';
import { PrinterState } from './store.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const onReadyEventMap = new Map();
function PrinterRoot() {
  const state = useObservedValue(PrinterState);
  const handleReadyEvent = useCallback(() => {
    if (!state?.contentKey) {
      return;
    }
    const readyEvent = onReadyEventMap.get(state.contentKey);
    if (!readyEvent || readyEvent.triggered) {
      return;
    }
    readyEvent.triggered = true;
    readyEvent.cb();
  }, [state?.contentKey]);
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    children: /*#__PURE__*/jsxs(PrintContext.Provider, {
      value: true,
      children: [/*#__PURE__*/jsx("div", {
        className: cx(printerSelectors.container.className, resets.rootCls),
        "aria-hidden": true
        // @ts-expect-error "true" is required for React to flush value
        ,
        inert: !state?.input.debug ? "true" : undefined,
        children: state && state.input?.sections.length ? /*#__PURE__*/jsx(PrintRoot, {
          target: state.target,
          input: state.input,
          onReady: handleReadyEvent
        }, state.contentKey) : /*#__PURE__*/jsx(Fragment, {})
      }), /*#__PURE__*/jsx("div", {
        className: printerSelectors.throbber.className,
        "aria-hidden": true
        // @ts-expect-error "true" is required for React to flush value
        ,
        inert: "true",
        children: /*#__PURE__*/jsx(PrinterThrobber, {})
      })]
    })
  });
}

export { PrinterRoot, onReadyEventMap };
//# sourceMappingURL=comp.root.js.map
